



















import { computed, defineComponent } from '@vue/composition-api';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import i18n, { i18n_t } from '@/locales/i18n';

export default defineComponent({
  name: 'UpgradeDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const store = context.root.$store;
    const bodyContent = computed(() =>
      store.getters.isPrivate
        ? i18n_t('游客模式暂不支持该体验，请切换网盘用户登录后尝试')
        : i18n_t('游客模式暂不支持该体验，请升级为网盘企业用户后尝试'),
    );
    const methods = {
      close() {
        innerShow.value = false;
      },
      upgrade() {
        dispatchRouter(CONSTANT_URL.buyEnterpriseUrl);
      },
    };

    return {
      bodyContent,
      innerShow,
      ...methods,
    };
  },
});
